import { NavLink, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import useAuth from '../hooks/useAuth';

import { logout } from '../services/MockAuthService';

import './console-navbar.css';
import logo from './logo.png';
import noAvatar from './no_profile.svg';

function ConsoleNavbar() {
  const navigate = useNavigate();
  const auth = useAuth();
  const user = auth.getSession();

  const handleLogout = async (e) => {
    e.preventDefault();

    await logout();
    navigate('/');
  };

  return (
    <>
      <div
        id="header"
        className="mdk-header bg-dark js-mdk-header m-0"
        data-effects="waterfall"
      >
        <div className="mdk-header__content">
          {/* Navbar */}
          <nav
            id="default-navbar"
            className="navbar navbar-expand navbar-dark sticky-top bg-primary m-0"
          >
            <div className="container">
              {/* Brand */}
              <a className="navbar-brand d-flex pt-2">
                <img src={logo} alt="" className="navbar-logo logo-shadow"/>
                <span className="d-xs-md-block brand-title">Member Portal</span>
              </a>
              <div className="flex"/>
              <Dropdown className="nav navbar-nav flex-nowrap" align="end" id="dropdown-menu-align-end">
                <Dropdown.Toggle className="nav-link dropdown-toggle" variant="success" id="avatar-dropdown">
                    <span className="username">{user.FULL_NAME}</span>
                  <img className="rounded-circle user-avatar" src={noAvatar} alt=""/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item><button className="dropdown-item" onClick={() => navigate('/console/update-nida')}>Update NIDA Number</button></Dropdown.Item>
                  <Dropdown.Item><button className="dropdown-item" onClick={() => navigate('/console/reset')}>Reset Password</button></Dropdown.Item>
                  <Dropdown.Item><button className="dropdown-item" onClick={handleLogout}>Logout</button></Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </nav>
          {/* // END Navbar */}
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <button className="navbar-toggler collapsed o-0"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarMenu"
                  aria-controls="navbarMenu"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"/>
            <span id="menu-name">MENU</span>
          </button>
          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav">
              <li className="nav-item">
                <NavLink className="nav-link" to='/console/dashboard'> Dashboard</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to='/console/contribution'> Contribution</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to='/console/benefit'> Benefit</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to='/console/complaint'> Complaint</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default ConsoleNavbar;
